import BaseRepository from '@/repositories/base/BaseRepository';

class CpsRepository extends BaseRepository {
  // 预测提升流量查询
  predictBoostTrafficList(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/cps-apply-order/predict-boost-traffic-list',
      data: params,
    });
  }
  //查询策略提升配置列表
  upgradePolicyList() {
    return this.get<any>({
      url: '/ebk-dkb-api/cps-apply-order/upgrade-policy-list',
      data: {},
    });
  }
  //推广列表
  myCpsList(params: any) {
    return this.get<any>({
      url: '/ebk-dkb-api/cps-apply-order/my-cps-list',
      data: params,
    });
  }


  //推广创建
  createPlus(params: any) {
    return this.get<any>({
      url: '/ebk-dkb-api/cps-apply-order/create-plus',
      data: params,
    });
  }

  //推广详情
  cpsQueryInfo(params: any) {
    return this.get<any>({
      url: '/ebk-dkb-api/cps-apply-order/cps-query-info',
      data: params,
    });
  }
  //推广详情取消确认
  hotelConfirm(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/cps-apply-order/hotel-confirm',
      data: params,
    });
  }
   //创建留资信息
   saveRetainedCapital(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/hotel-retained-capital/save-retained-capital',
      data: params,
    });
  }    
  
  //财务结算列表
  settlementList(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/cps-popularize/settlement-list',
      data: params,
    });
  } 
  //财务结算列表信息
  settlementReviewProcess(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/cps-popularize/settlement-review-process',
      data: params,
    });
  } 

  //财务结算上传发票信息
  uploadInvoice(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/cps-popularize/upload-invoice',
      data: params,
    });
  } 
  //财务结算发票日志
  getInvoiceLogList(params: any) {
      return this.post<any>({
        url: '/ebk-dkb-api/cps-popularize/get-invoice-log-list',
        data: params,
      });
    } 

    //财务结算明细
    settlementDetail(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/cps-popularize/settlement-detail',
      data: params,
    });
  } 


    //生意金账单记录列表
    settlementRechargeList(params: any) {
      return this.post<any>({
        url: '/ebk-dkb-api/fip-sale-room-config/settlement-recharge-list',
        data: params,
      });
    } 

    
    //生意金状态
    checkHaveFipSaleRoom() {
      return this.post<any>({
        url: '/ebk-dkb-api/fip-sale-room-config/check-have-fip-sale-room',
        data: {},
      });
    } 
   


  

  

  

}

export default CpsRepository;
